import { KatLitFilteredElement, register } from '../../shared/base';
import { KatBlueprintDashboard } from '.';

/**
 * @component {kat-blueprint-dashboard-action} KatBlueprintDashboardAction Component used to place and filter components within the action section.
 * @slot default Blueprint content for action section.
 */
@register(KatBlueprintDashboard.slotMapping.action.name)
export class KatBlueprintDashboardAction extends KatLitFilteredElement {
  constructor() {
    super(
      KatBlueprintDashboard.slotMapping.action.name,
      KatBlueprintDashboard.slotMapping.action.allowed
    );
  }
}
